import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable, switchMap } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { logInterface } from 'src/app/util/interfaces/log.interface';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class CmdbRegisterPageLogsService {
	private labelsService = inject(LabelsService);
	private http = inject(HttpClient);
	private authLoginService = inject(AuthLoginService);

	private getCiLogsUrl = environment.baseApiUrl + 'cmdb/logs/{idCi}';

	constructor() {}

	getCiLogs(idCi: string): Observable<logInterface[]> {
		const getCiLogsUrl = this.getCiLogsUrl.replace('{idCi}', idCi);

		return this.labelsService.getLabels().pipe(
			switchMap((labels) => {
				return this.http.get<JSON[]>(getCiLogsUrl, { headers: this.authLoginService.getHttpHeaders() }).pipe(
					map((logRes) => {
						const newLogInterfaceArray: logInterface[] = [];
						logRes.forEach((log: any) => {
							const newLog: logInterface = {
								status: log.action,
								duration: '',
								file_log: [],
								analyst: log.email,
								idLog: '',
								log_date: log.created_at,
								notes: log.message.replaceAll(/§+/g, ', '),
							};

							newLogInterfaceArray.push(newLog);
						});

						return newLogInterfaceArray;
					})
				);
			})
		);
	}
}
